import './Main/admin/1Controllers.js';
import './Main/admin/2Routes.js';
import './Main/admin/adminBusinessUnits/1Controllers.js';
import './Main/admin/adminBusinessUnits/2Routes.js';
import './Main/admin/adminBusinessUnits/3Service.js';
import './Main/admin/adminBusinessUnits/BusinessUnitEditController.js';
import './Main/admin/adminBusinessUnits/BusinessUnitsController.js';
import './Main/admin/adminBusinessUnits/SearchEmployeeController.js';
import './Main/admin/AdminController.js';
import './Main/admin/adminDefaultEntitlement/1Controllers.js';
import './Main/admin/adminDefaultEntitlement/2Routes.js';
import './Main/admin/adminDefaultEntitlement/3Service.js';
import './Main/admin/adminDefaultEntitlement/AddDefaultEntitlementCtrl.js';
import './Main/admin/adminDefaultEntitlement/BaseFeatureCtrl.js';
import './Main/admin/adminDefaultEntitlement/BySystemRoleCtrl.js';
import './Main/admin/adminDefaultEntitlement/MainDefaultEntitlementCtrl.js';
import './Main/admin/adminDefaultEntitlement/ViewExistingRightsCtrl.js';
import './Main/admin/adminDefaultEntitlement/ViewSupervisorDetailsController.js';
import './Main/admin/adminEmailTemplates/1Controllers.js';
import './Main/admin/adminEmailTemplates/2Routes.js';
import './Main/admin/adminEmailTemplates/3Service.js';
import './Main/admin/adminEmailTemplates/EditEmailTemplateController.js';
import './Main/admin/adminEmailTemplates/EmailTemplateController.js';
import './Main/admin/adminEmailTemplates/MainEmailTemplatesController.js';
import './Main/admin/adminEmailTemplates/SideBarController.js';
import './Main/admin/adminSupervisorReview/1Controllers.js';
import './Main/admin/adminSupervisorReview/2Routes.js';
import './Main/admin/adminSupervisorReview/3Services.js';
import './Main/admin/adminSupervisorReview/ActionOnCardsSupervisorCtrl.js';
import './Main/admin/adminSupervisorReview/AdminSupervisorAccessReviewController.js';
import './Main/admin/adminSystemOwnerReview/1Controllers.js';
import './Main/admin/adminSystemOwnerReview/2Routes.js';
import './Main/admin/adminSystemOwnerReview/3Services.js';
import './Main/admin/adminSystemOwnerReview/ActionOnCardsSystemOwnerController.js';
import './Main/admin/adminSystemOwnerReview/AdministrationController.js';
import './Main/employee/1Controllers.js';
import './Main/employee/2Routes.js';
import './Main/employee/3Service.js';
import './Main/employee/AllProfilesController.js';
import './Main/employee/ContactInfoController.js';
import './Main/employee/ContactInfoPrimaryController.js';
import './Main/employee/ContactInfoSecondaryController.js';
import './Main/employee/EmployeeController.js';
import './Main/employee/EmployeeDepartureController.js';
import './Main/employee/PasswordResetController.js';
import './Main/employee/PasswordResetSelectSystemController.js';
import './Main/employee/PendingEmployeeController.js';
import './Main/employee/PositionInHierarchyController.js';
import './Main/employee/PreAuthorizationsController.js';
import './Main/employee/SidebarController.js';
import './Main/employee/SummaryController.js';
import './Main/employee/SummaryOperationalTasksController.js';
import './Main/employee/SystemBusinessTasksController.js';
import './Main/home/1Controllers.js';
import './Main/home/2Routes.js';
import './Main/home/FeatureMyProfileController.js';
import './Main/home/HomeController.js';
import './Main/hr/1Controllers.js';
import './Main/hr/2Routes.js';
import './Main/hr/confirmations/1Controllers.js';
import './Main/hr/confirmations/2Routes.js';
import './Main/hr/confirmations/ConfirmationsController.js';
import './Main/hr/confirmations/ConfirmationsFacetsController.js';
import './Main/hr/confirmations/ConfirmationsInProgressController.js';
import './Main/hr/confirmations/ConfirmationsPagingController.js';
import './Main/hr/HRController.js';
import './Main/itPurchasing/1Controllers.js';
import './Main/itPurchasing/2Routes.js';
import './Main/itPurchasing/3services.js';
import './Main/itPurchasing/ItPurchasingActionsController.js';
import './Main/itPurchasing/ItPurchasingAssignController.js';
import './Main/itPurchasing/ItPurchasingAssignMultiSelectController.js';
import './Main/itPurchasing/ItPurchasingController.js';
import './Main/itPurchasing/ItPurchasingMultiSelectActionsController.js';
import './Main/itPurchasing/ItPurchasingSatusFiltersController.js';
import './Main/itPurchasing/itPurchasingSystemCardDirective.js';
import './Main/SearchBox/1Controllers.js';
import './Main/SearchBox/focusOnMainSearchDirective.js';
import './Main/selfAccessRequest/1Controllers.js';
import './Main/selfAccessRequest/2Routes.js';
import './Main/selfAccessRequest/adHoc/1Controllers.js';
import './Main/selfAccessRequest/adHoc/2Routes.js';
import './Main/selfAccessRequest/adHoc/AdHocController.js';
import './Main/selfAccessRequest/adHoc/otherCatalog/OtherCatalogController.js';
import './Main/selfAccessRequest/adHoc/preAuthorized/BySystemType.js';
import './Main/selfAccessRequest/adHoc/preAuthorized/BySystemTypeListController.js';
import './Main/selfAccessRequest/adHoc/removeRights/BySystemType.js';
import './Main/selfAccessRequest/adHoc/removeRights/BySystemTypeListController.js';
import './Main/selfAccessRequest/adHoc/removeRights/RemoveRightsExplanationController.js';
import './Main/selfAccessRequest/adHoc/sameAs/BySystemType.js';
import './Main/selfAccessRequest/adHoc/sameAs/BySystemTypeListController.js';
import './Main/selfAccessRequest/adHoc/sameAs/SideBarSameAsController.js';
import './Main/selfAccessRequest/adHoc/specialNeeds/OtherNeedsController.js';
import './Main/selfAccessRequest/adHoc/submit/AdHocConfirmationController.js';
import './Main/selfAccessRequest/arrival/1Controllers.js';
import './Main/selfAccessRequest/arrival/2Routes.js';
import './Main/selfAccessRequest/arrival/ArrivalCompletedController.js';
import './Main/selfAccessRequest/arrival/ArrivalController.js';
import './Main/selfAccessRequest/arrival/locationEquipment/LocationEquipmentController.js';
import './Main/selfAccessRequest/arrival/locationEquipment/LocationEquipmentExplanationController.js';
import './Main/selfAccessRequest/arrival/otherCatalog/OtherCatalogController.js';
import './Main/selfAccessRequest/arrival/preAuthorized/BySystemType.js';
import './Main/selfAccessRequest/arrival/preAuthorized/BySystemTypeListController.js';
import './Main/selfAccessRequest/arrival/preAuthorizedDelta/BySystemType.js';
import './Main/selfAccessRequest/arrival/preAuthorizedDelta/BySystemTypeListController.js';
import './Main/selfAccessRequest/arrival/sameAs/BySystemType.js';
import './Main/selfAccessRequest/arrival/sameAs/BySystemTypeListController.js';
import './Main/selfAccessRequest/arrival/sameAs/SideBarSameAsController.js';
import './Main/selfAccessRequest/arrival/specialNeeds/OtherNeedsController.js';
import './Main/selfAccessRequest/arrival/submit/ArrivalSubmitController.js';
import './Main/selfAccessRequest/SelfAccessRequestController.js';
import './Main/staticHtmlPage/1Controllers.js';
import './Main/staticHtmlPage/2Routes.js';
import './Main/staticHtmlPage/3services.js';
import './Main/staticHtmlPage/StaticHtmlPageController.js';
import './Main/supervisor/supervisorAccessReview/1Controllers.js';
import './Main/supervisor/supervisorAccessReview/2Routes.js';
import './Main/supervisor/supervisorAccessReview/3Service.js';
import './Main/supervisor/supervisorAccessReview/AccessReviewController.js';
import './Main/supervisor/supervisorAccessReview/ActionsOnCardSysRoleEmployeeController.js';
import './Main/supervisor/supervisorAccessReview/AuthUserController.js';
import './Main/supervisor/supervisorAccessReview/NextSystemToReviewController.js';
import './Main/supervisor/supervisorAccessReview/ProgressBar_SystemToReviewController.js';
import './Main/supervisor/supervisorAccessReview/SideBarCtrl.js';
import './Main/supervisor/supervisorAccessReview/SubmitCtrl.js';
import './Main/supervisor/supervisorAccessReview/SummaryCtrl.js';
import './Main/supervisor/supervisorAccessReview/systemToReviewCtrl.js';
import './Main/supervisor/supervisorAccessReview/WelcomeCtrl.js';
import './Main/supervisor/supervisorAuthorizingUserRequest/1Controllers.js';
import './Main/supervisor/supervisorAuthorizingUserRequest/2Routes.js';
import './Main/supervisor/supervisorAuthorizingUserRequest/3Service.js';
import './Main/supervisor/supervisorAuthorizingUserRequest/CardSupervisorAuthorisingRequestController.js';
import './Main/supervisor/supervisorAuthorizingUserRequest/MainSupervisorAuthorizingController.js';
import './Main/supervisor/supervisorAuthorizingUserRequest/NotAvailableController.js';
import './Main/supervisor/supervisorAuthorizingUserRequest/SupervisorAuthorizingRequestController.js';
import './Main/systemOwnerReview/1Controllers.js';
import './Main/systemOwnerReview/2Routes.js';
import './Main/systemOwnerReview/AuthUserController.js';
import './Main/systemOwnerReview/CompletedController.js';
import './Main/systemOwnerReview/confirmSystemOwnership/1Controllers.js';
import './Main/systemOwnerReview/confirmSystemOwnership/2Routes.js';
import './Main/systemOwnerReview/confirmSystemOwnership/3Service.js';
import './Main/systemOwnerReview/confirmSystemOwnership/BySystemTypeController.js';
import './Main/systemOwnerReview/confirmSystemOwnership/ConfirmSystemOwnershipController.js';
import './Main/systemOwnerReview/confirmSystemOwnership/ExplanationController.js';
import './Main/systemOwnerReview/confirmSystemOwnership/SideBarConfirmOwnershipController.js';
import './Main/systemOwnerReview/decommissionSystems/1Controllers.js';
import './Main/systemOwnerReview/decommissionSystems/2Routes.js';
import './Main/systemOwnerReview/decommissionSystems/3Service.js';
import './Main/systemOwnerReview/decommissionSystems/BySystemTypeController.js';
import './Main/systemOwnerReview/decommissionSystems/DecommissionSystemsController.js';
import './Main/systemOwnerReview/decommissionSystems/ExplanationController.js';
import './Main/systemOwnerReview/decommissionSystems/SideBarDecommissionSystemsController.js';
import './Main/systemOwnerReview/decommissionSystems/SummaryDecommissionSystemsModalController.js';
import './Main/systemOwnerReview/GettingStartedController.js';
import './Main/systemOwnerReview/MainSystemOwnerReviewController.js';
import './Main/systemOwnerReview/reviewUniquePermissions/1Controllers.js';
import './Main/systemOwnerReview/reviewUniquePermissions/2Routes.js';
import './Main/systemOwnerReview/reviewUniquePermissions/3Service.js';
import './Main/systemOwnerReview/reviewUniquePermissions/BySystemTypeController.js';
import './Main/systemOwnerReview/reviewUniquePermissions/ExplanationController.js';
import './Main/systemOwnerReview/reviewUniquePermissions/ReviewUniquePermissionsController.js';
import './Main/systemOwnerReview/reviewUniquePermissions/SideBarUniquePermissionsController.js';
import './Main/systemOwnerReview/reviewUniquePermissions/UniquePermissionCardDirective.js';
import './Main/systemOwnerUserRequest/1Controllers.js';
import './Main/systemOwnerUserRequest/2Routes.js';
import './Main/systemOwnerUserRequest/3Service.js';
import './Main/systemOwnerUserRequest/CardNetworkShareController.js';
import './Main/systemOwnerUserRequest/CardSystemRolePendingController.js';
import './Main/systemOwnerUserRequest/MainSystemOwnerUserRequestController.js';
import './Main/userRequest/1Controllers.js';
import './Main/userRequest/2Routes.js';
import './Main/userRequest/DisplayRequestsController.js';
import './Main/userRequest/LookupEmployeeCtrl.js';
import './Main/userRequest/MainAccessRequestCtrl.js';
import './Main/userRequest/SideBarCtrl.js';
import './Main/userRequest/userRequestArrival/1Controllers.js';
import './Main/userRequest/userRequestArrival/2Routes.js';
import './Main/userRequest/userRequestArrival/3Service.js';
import './Main/userRequest/userRequestArrival/RequestArrivalController.js';
import './Main/userRequest/userRequestArrival/RequestArrivalWithEventIDController.js';
import './Main/userRequest/userRequestEdit/1Controllers.js';
import './Main/userRequest/userRequestEdit/2Routes.js';
import './Main/userRequest/userRequestEdit/3EditService.js';
import './Main/userRequest/userRequestEdit/ActionsController.js';
import './Main/userRequest/userRequestEdit/ByBusinessTaskController.js';
import './Main/userRequest/userRequestEdit/ByNetworkShareController.js';
import './Main/userRequest/userRequestEdit/BySystemTypeController.js';
import './Main/userRequest/userRequestEdit/DisplayArrivalInformationController.js';
import './Main/userRequest/userRequestEdit/DisplayEventsController.js';
import './Main/userRequest/userRequestEdit/GettingStartedController.js';
import './Main/userRequest/userRequestEdit/LocationEquipmentController.js';
import './Main/userRequest/userRequestEdit/MainController.js';
import './Main/userRequest/userRequestEdit/MissingAdmAccountController.js';
import './Main/userRequest/userRequestEdit/MissingHighPrivilegesController.js';
import './Main/userRequest/userRequestEdit/MissingSystemAccountController.js';
import './Main/userRequest/userRequestEdit/MoreInfosController.js';
import './Main/userRequest/userRequestEdit/NavigateBusinessTaskController.js';
import './Main/userRequest/userRequestEdit/NavigateSystemTypeController.js';
import './Main/userRequest/userRequestEdit/NetworkShareDirective.js';
import './Main/userRequest/userRequestEdit/NotEnoughPrivilegesController.js';
import './Main/userRequest/userRequestEdit/SameAsDirective.js';
import './Main/userRequest/userRequestEdit/SelectEmployeeSameAsModalController.js';
import './Main/userRequest/userRequestEdit/SelectSystemRolesModalController.js';
import './Main/userRequest/userRequestEdit/SideBarBusinessTasksController.js';
import './Main/userRequest/userRequestEdit/SideBarController.js';
import './Main/userRequest/userRequestEdit/SystemAndRolesDirective.js';
import './Main/userRequest/userRequestEdit/TaskCardsController.js';
import './Main/userRequest/userRequestEdit/ValidationMessagesController.js';
import './Main/userRequest/userRequestEdit/WithBusinessTaskConflictController.js';
import './Main/userRequest/userRequestProcess/1Controllers.js';
import './Main/userRequest/userRequestProcess/2Routes.js';
import './Main/userRequest/userRequestProcess/3ProcessService.js';
import './Main/userRequest/userRequestProcess/CardITPurchasingInstructionsController.js';
import './Main/userRequest/userRequestProcess/CardSystemRolePendingController.js';
import './Main/userRequest/userRequestProcess/ProcessRequestCtrl.js';
